/* Forgot Password Form Model */
export class ForgotPasswordFormModel {
  /**
	 * @constructor
	 */
  constructor(
    public email?: any
  ) {  }
}